import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";

export default function ProductSyncButton({
    isSyncing,
    syncProducts,
}: {
    isSyncing: boolean;
    syncProducts: () => void;
}) {
    return (
        <Button
            variant="outline"
            onClick={syncProducts}
            disabled={isSyncing}
            className="flex items-center gap-2"
        >
            <RefreshCw
                className={`h-4 w-4 ${isSyncing ? "animate-spin" : ""}`}
            />
            {isSyncing ? "Syncing..." : "Sync"}
        </Button>
    );
}
